export default "__VITE_ASSET__DAvYsFBt__"